var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cve-trend-table-cell"},[_c('v-icon',{class:{ up: _vm.trendy, down: !_vm.trendy }},[_vm._v(" "+_vm._s(_vm.trendy ? 'trending_up': 'trending_down')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }